import React from "react";

interface ActivityWrapperProps {
  children?: React.ReactNode;
  handleRedirection?: () => void;
  experienceId?: number;
  onExpandActivities?: () => void;
  className?: string;
}

export const ActivityWrapper = ({
  children,
  handleRedirection,
  experienceId,
  onExpandActivities,
  className = "",
}: ActivityWrapperProps) => {
  return (
    <div
      className={`w-full px-1 mt-2 ${className}`}
      role="button"
      onClick={experienceId ? handleRedirection : onExpandActivities}
      id={experienceId ? `clickActivity_${experienceId}` : undefined}
    >
      <div
        className="w-full px-1 rounded-2xl bg-secondary-color/90 border border-[#4B4B4B] overflow-hidden"
        id={!experienceId ? `mobileFullScreenActivityDetails` : undefined}
      >
        {children}
      </div>
    </div>
  );
};
